module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }), _vm._v("Did Ya Hear the One About …?")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("A")]), _vm._v("fter most weddings someone, usually the groom’s friends, plays a prank on the newly married ample. After being married only a month, Raul Hortena realized the joke was on him when he appeared in front of a Barcelona court asking for a divorce. The judge turned down the request because he discovered that Raul-the-Fool had used invisible ink when he signed his marriage certificate. The "), _c('em', [_vm._v("Guardian")]), _vm._v(" reported that Raul was also fined approximately $200 for forging an official document."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("BONNIE BLOWS CLINTON")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Article regarding Hurricane Bonnie hitting Clinton, North Carolina."), _c('br'), _vm._v("— "), _c('em', [_vm._v("The Sampson Independent,")]), _vm._v(" August 27, 1998.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565303fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c07_r1.vue
// module id = 93
// module chunks = 0